import { BASE_URL, api } from "../config";

const OBSERVABILITY_SUMMARY = `${BASE_URL}observability/summary`;
const OBSERVABILITY_STORIES = `${BASE_URL}observability/stories`;
const OBSERVABILITY_REQUEST = `${BASE_URL}observability/request`;
const OBSERVABILITY_SECURITY_EVENTS = `${BASE_URL}observability/security-events`;

function withObservabilitySource(params = {}) {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return { ...params, source: "local" };
    }
    return params;
}

export function fetchObservabilitySummary(params = {}) {
    return api
        .get(OBSERVABILITY_SUMMARY, { params: withObservabilitySource(params) })
        .then((res) => res.data);
}

export function fetchObservabilityStories(params = {}) {
    return api
        .get(OBSERVABILITY_STORIES, { params: withObservabilitySource(params) })
        .then((res) => res.data);
}

export function fetchObservabilityRequestLogs(requestId, params = {}) {
    return api
        .get(`${OBSERVABILITY_REQUEST}/${encodeURIComponent(requestId)}`, { params: withObservabilitySource(params) })
        .then((res) => res.data);
}

export function fetchObservabilitySecurityEvents(params = {}) {
    return api
        .get(OBSERVABILITY_SECURITY_EVENTS, { params: withObservabilitySource(params) })
        .then((res) => res.data);
}
